import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 12H7V10H13V12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 8H7V6H17V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 13H23V22H1V13H3V2H21V13ZM5 13H8.90137L9.09473 13.751C9.42791 15.045 10.6036 16 12 16C13.3964 16 14.5721 15.045 14.9053 13.751L15.0986 13H19V4H5V13Z"}}]};

const DraftFilled = Vue.extend<IconProps>({
  name: 'DraftFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'draft-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DraftFilled;
